module.exports = __webpack_public_path__ + "img/nudge-m10-3.e43449da.png";